export default "__VITE_ASSET__DIrBVTq5__"